import React from 'react';

import { useTranslation } from '@lt/localization';

import { Input } from '../../Input';

type Props = {
  name: string;
};

export const EmailInput = ({ name }: Props) => {
  const { t } = useTranslation();
  return (
    <Input
      name={name}
      header={t('checkout.emailInput.header')}
      placeholder={t('checkout.emailInput.placeholder')}
      type="email"
      nativeInputProps={{
        autoComplete: 'email',
        inputMode: 'email',
      }}
    />
  );
};
